export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  featured: boolean;
  content: ArticleSection[];
  tags: string[];
}

export interface ArticleSection {
  type: 'heading' | 'paragraph' | 'image' | 'list' | 'tip';
  level?: 2 | 3;
  content?: string;
  items?: string[];
  imageSeq?: string;
  imageAlt?: string;
  caption?: string;
}

export const articles: Article[] = [
  {
    slug: '2024-guochanshouji-zipaizhaoxiang-paihangbang',
    title: '2024年国产手机自拍效果排行榜：这5款拍照最出片',
    excerpt: '综合前置摄像头像素、AI美颜算法、夜景自拍等多个维度，我们实测了市面上最热门的国产手机，为你推荐最适合自拍的机型。',
    category: 'shebei-xuangou',
    author: '摄影小陈',
    date: '2024-11-15',
    readTime: '8分钟',
    imageSeq: 'phone-ranking-hero',
    featured: true,
    tags: ['国产手机', '自拍手机推荐', '手机选购', '拍照评测'],
    content: [
      { type: 'heading', level: 2, content: '为什么要选国产手机自拍？' },
      { type: 'paragraph', content: '近年来，国产手机在影像领域取得了令人瞩目的进步。从前置摄像头的像素提升到AI算法的深度优化，国产手机在人像自拍方面的表现已经完全不输国际大牌，甚至在某些场景下更懂亚洲用户的审美需求。国产自拍技术的持续突破，让更多用户能够轻松拍出令人满意的自拍照片。' },
      { type: 'image', imageSeq: 'phone-camera-comparison', imageAlt: '国产手机前置摄像头对比', caption: '主流国产手机前置摄像头参数对比' },
      { type: 'heading', level: 2, content: '第一名：华为Pura 70 Ultra' },
      { type: 'paragraph', content: '华为Pura 70 Ultra搭载了1300万像素前置超广角摄像头，配合XD Fusion Pro图像引擎，在逆光和暗光环境下表现出色。其AI人像美化算法能够智能识别面部特征，在保留皮肤质感的同时自然优化肤色，成片效果极具高级感。国产自拍算法的领先水平在这款手机上得到了充分体现。' },
      { type: 'heading', level: 2, content: '第二名：vivo X100 Pro' },
      { type: 'paragraph', content: 'vivo一直以"照亮你的美"为品牌理念，X100 Pro前置3200万像素摄像头配合蔡司光学镜头，画质清晰锐利。其自研V3影像芯片提供了专业级人像虚化效果，背景过渡自然柔美。值得一提的是，vivo的多场景美颜功能可以根据光线环境自动调整参数，无需手动设置就能获得最佳效果。' },
      { type: 'heading', level: 2, content: '第三名：OPPO Find X7 Ultra' },
      { type: 'paragraph', content: 'OPPO Find X7 Ultra前置3200万像素索尼IMX709传感器，支持自动对焦，自拍时对焦迅速准确。其自然美颜3.0算法强调"真实美"，在保留个人特征的基础上进行微调，不会过度磨皮。夜景自拍模式下，通过多帧合成技术有效压制噪点，暗光环境也能拍出清晰明亮的自拍。' },
      { type: 'heading', level: 2, content: '第四名：小米14 Ultra' },
      { type: 'paragraph', content: '小米14 Ultra前置3200万像素摄像头，得益于徕卡联合调校的影像系统，自拍色彩风格独特，带有经典的徕卡影调。人像模式支持多种徕卡滤镜，一键拍出有质感的胶片风格自拍。前置摄像头还支持4K 60fps视频录制，非常适合vlog创作者。' },
      { type: 'heading', level: 2, content: '第五名：荣耀Magic6 Pro' },
      { type: 'paragraph', content: '荣耀Magic6 Pro前置5000万像素超高清摄像头，是同级别中像素最高的前置镜头之一。配合AI体感识别技术，可以实现隔空手势拍照，解放双手拍出更有创意的自拍角度。其人像引擎能够精准分离人物与背景，实现单反级别的背景虚化效果。' },
      { type: 'tip', content: '小贴士：选购自拍手机时，不要只看前置摄像头像素，还要关注传感器尺寸、光圈大小以及厂商的算法调校水平。建议到线下实体店亲自试拍对比，找到最适合自己肤质和风格的那一款。' },
    ],
  },
  {
    slug: 'zizai-goutu-sanfenfa-jiqiao',
    title: '自拍构图三分法：5分钟掌握手机自拍黄金法则',
    excerpt: '三分法是最基础也最实用的自拍构图技巧。学会这一招，你的自拍水平将立刻提升一个档次。本文详细讲解三分法在自拍中的实际应用。',
    category: 'goutu-jiqiao',
    author: '构图达人阿明',
    date: '2024-10-28',
    readTime: '6分钟',
    imageSeq: 'composition-rule-of-thirds',
    featured: true,
    tags: ['自拍构图', '三分法', '摄影基础', '手机拍照技巧'],
    content: [
      { type: 'heading', level: 2, content: '什么是三分法构图？' },
      { type: 'paragraph', content: '三分法（Rule of Thirds）是摄影中最基础也最经典的构图法则。想象将画面用两条横线和两条竖线均匀分成九个等大的方格，把拍摄主体放在这些线条的交点上，或者沿着线条排列，就能得到更具视觉美感的画面。这一技巧在国产自拍中同样适用，是提升自拍质感的第一步。' },
      { type: 'image', imageSeq: 'rule-of-thirds-grid-demo', imageAlt: '三分法构图网格示意图', caption: '三分法构图：将画面分为九等份，主体放在交点处' },
      { type: 'heading', level: 2, content: '自拍中三分法的三种经典应用' },
      { type: 'heading', level: 3, content: '1. 眼睛放在上三分线' },
      { type: 'paragraph', content: '这是最基础的自拍三分法。将你的眼睛对准画面上方的三分之一处。大多数手机相机设置中都可以开启网格线辅助功能，打开后你就能在屏幕上看到九宫格线条，直接把眼睛对上横线即可。这样拍出来的自拍，画面比例非常舒适，不会出现头顶留白过多或下巴被切掉的问题。' },
      { type: 'heading', level: 3, content: '2. 人像放在左右三分线交点' },
      { type: 'paragraph', content: '不一定要把人脸放在画面正中央。尝试将你的脸或身体放在左侧或右侧的竖线与横线的交点上，另一侧留出空间展示背景。这种"偏离中心"的构图方式能让自拍更有故事感和呼吸感。如果背景中有好看的风景、建筑或灯光，这种构图方式尤其适用。' },
      { type: 'heading', level: 3, content: '3. 引导线+三分点组合' },
      { type: 'paragraph', content: '当背景中有自然的线条（如道路、栏杆、建筑边缘）时，可以让这些线条从画面一角延伸至三分点附近，同时将人物主体放在对侧的三分点上。这种组合构图手法能让画面层次丰富，视觉引导性强，是进阶自拍的必备技巧之一。' },
      { type: 'heading', level: 2, content: '常见错误与纠正' },
      { type: 'list', items: ['头顶留白太多：将眼睛对准上三分线，而不是头顶', '下巴卡在画面边缘：手机举高一点，稍微俯拍', '背景线条歪斜：打开网格线，确保水平线是平的', '主体居中呆板：尝试偏移到左右三分点，增加画面趣味性'] },
      { type: 'tip', content: '高手技巧：拍摄时故意在人物视线方向留出更多空间（称为"视线空间"或"呼吸空间"），这样画面看起来会更加自然舒展，不会给人"撞墙"的压迫感。' },
    ],
  },
  {
    slug: 'ziran-guang-zhuajian-zimei',
    title: '自然光自拍秘籍：不用补光灯也能拍出高级感',
    excerpt: '学会利用自然光是自拍进阶的关键。本文将教你如何在不同时段、不同天气条件下，纯靠自然光拍出拥有专业质感的自拍照片。',
    category: 'buguang-dengguang',
    author: '光线玩家Lily',
    date: '2024-10-15',
    readTime: '7分钟',
    imageSeq: 'natural-light-selfie',
    featured: true,
    tags: ['自然光', '自拍布光', '光线运用', '高级感自拍'],
    content: [
      { type: 'heading', level: 2, content: '为什么自然光是自拍最好的光源？' },
      { type: 'paragraph', content: '自然光拥有任何人工光源都无法完全复制的柔和质感与丰富层次。尤其是对国产自拍来说，善用自然光可以最大程度发挥手机摄像头的性能优势。自然光的光线方向、色温和强度会随时间变化，了解这些变化规律，就能在不同的时段拍出不同风格的自拍。' },
      { type: 'heading', level: 2, content: '黄金时刻：日出后和日落前1小时' },
      { type: 'paragraph', content: '摄影爱好者常说的"黄金时刻"（Golden Hour），是指日出后和日落前约一小时的时段。这时的阳光呈现出温暖的金色调，光线柔和且带有方向性，是自拍的绝佳时机。面向光源拍摄可以得到温暖柔美的肤色；侧光拍摄则能塑造立体脸型，突出五官轮廓。' },
      { type: 'image', imageSeq: 'golden-hour-selfie-demo', imageAlt: '黄金时刻自然光自拍效果展示', caption: '利用黄金时刻的柔和阳光，无需滤镜即可拍出温暖质感' },
      { type: 'heading', level: 2, content: '窗口光：室内自拍的神器' },
      { type: 'paragraph', content: '如果你在室内自拍，最理想的位置就是面对一扇大窗户。来自窗户的散射光柔和均匀，相当于一个巨大的柔光箱。让窗户在你的正前方或45度角方向，光线会自然地在脸上形成柔和的明暗过渡，拍出"天生好皮"的效果。注意避开正午的直射强光，那会让面部出现过曝和高光溢出。' },
      { type: 'heading', level: 2, content: '阴天：意想不到的自拍好天气' },
      { type: 'paragraph', content: '很多人觉得阴天不适合拍照，但其实阴天的光线对自拍来说非常友好。云层就像一个天然的巨型柔光罩，将阳光均匀散射到地面，消除了刺眼的阴影和过强的反差。在阴天自拍，肤色均匀柔和，细节保留充分，后期调色也有更大的发挥空间。' },
      { type: 'heading', level: 2, content: '逆光自拍：制造梦幻氛围' },
      { type: 'paragraph', content: '逆光自拍是营造氛围感的利器。背对光源拍摄时，光线从身后透过，会在头发和身体轮廓上形成一圈温暖的光晕（俗称"发丝光"）。这时需要注意用曝光补偿或HDR模式确保面部不会太暗。大多数国产手机的AI场景识别都能自动检测逆光场景并优化曝光。' },
      { type: 'tip', content: '实用技巧：如果你不确定光线从哪个方向来最好看，可以原地慢慢旋转一圈，同时观察手机屏幕中面部光影的变化。找到让五官最立体、肤色最好看的角度后停下来拍摄。这个简单的"找光转圈法"是很多专业自拍博主的私藏技巧。' },
    ],
  },
  {
    slug: 'shouji-xiutu-app-tuijian',
    title: '5款手机修图App横向评测：国产自拍后期修图利器推荐',
    excerpt: '从免费到专业级，我们测试了市面上最热门的手机修图App。帮你选出最适合自己的美颜修图工具，让每一张自拍都精致出彩。',
    category: 'houqi-xiutu',
    author: '修图师老王',
    date: '2024-09-20',
    readTime: '10分钟',
    imageSeq: 'photo-editing-apps',
    featured: false,
    tags: ['修图App', '美颜软件', '后期修图', '手机修图'],
    content: [
      { type: 'heading', level: 2, content: '国产修图App的崛起' },
      { type: 'paragraph', content: '曾几何时，手机修图还是Photoshop和Lightroom的天下，但如今国产修图App已经凭借更懂亚洲审美的美颜算法和更便捷的操作体验，占据了绝对的主导地位。从美图秀秀到醒图，每一款国产自拍修图软件都有其独特的优势和适用场景。' },
      { type: 'heading', level: 2, content: '第一名：醒图 — 全能型修图王者' },
      { type: 'paragraph', content: '醒图是近年崛起最快的修图App，以其自然不假面的美颜效果著称。其核心优势在于AI智能识别面部特征后进行精细化调整，而不是简单粗暴的全局磨皮。特别是"肤质优化"功能，可以在保留毛孔、细纹等真实质感的同时，让肤色均匀透亮，拍出来的自拍有一种"天生好皮肤"的高级感。' },
      { type: 'heading', level: 2, content: '第二名：美图秀秀 — 国民级修图神器' },
      { type: 'paragraph', content: '作为国产修图App的老牌选手，美图秀秀拥有最庞大的用户基础和最丰富的滤镜库。其"一键美颜"功能经过多年迭代已经非常成熟，尤其适合修图新手快速上手。此外，美图秀秀的"去瑕疵"工具可以精准去除痘痘、斑点等局部问题，而不会影响整体肤质表现。' },
      { type: 'heading', level: 2, content: '第三名：轻颜相机 — 拍照即修图' },
      { type: 'paragraph', content: '轻颜相机的独特之处在于"拍照即修图"的理念。它不是一个后期修图工具，而是一个内置了实时美颜算法的相机App。在拍摄时就完成美颜处理，所见即所得，省去了后期步骤。其"原生模式"最大限度保留了面部细节，非常适合追求自然效果的国产自拍爱好者。' },
      { type: 'heading', level: 2, content: '第四名：Snapseed — 专业级精修工具' },
      { type: 'paragraph', content: '由Google出品的Snapseed虽然不是国产App，但其强大的局部调整功能值得推荐。使用"选择性调整"工具可以对画面任意区域进行亮度、对比度、饱和度的精细控制。配合"修复"工具去除背景中的杂物和干扰元素，是追求完美画面的进阶用户的必备工具。' },
      { type: 'heading', level: 2, content: '第五名：VSCO — 胶片色调之王' },
      { type: 'paragraph', content: 'VSCO以其独特的胶片色调滤镜闻名，是打造高级感色调的首选。虽然其基础功能免费版有限，但付费会员可以解锁超过200款高品质预设滤镜。将自拍导入VSCO后，选择一个适合的胶片预设，再微调曝光和色温，就能轻松获得杂志级别的高级色调。' },
      { type: 'tip', content: '修图建议：少即是多。最好的修图效果是"看不出修过"。建议遵循"三步原则"——先调整曝光和白平衡，再微调肤色和瑕疵，最后加一点滤镜氛围。每一步都不要过度，保持在人眼看起来自然的范围内。' },
    ],
  },
  {
    slug: 'yeshi-zimei-zhinan',
    title: '城市夜景自拍全攻略：拒绝糊片，拍出璀璨夜色人像',
    excerpt: '夜晚的城市灯光是最美的自拍背景，但弱光环境下的自拍也是最容易翻车的场景。这篇攻略帮你解决夜景自拍的所有难题。',
    category: 'paizhe-changjing',
    author: '夜拍达人Tony',
    date: '2024-09-08',
    readTime: '7分钟',
    imageSeq: 'night-selfie-city',
    featured: false,
    tags: ['夜景自拍', '城市夜景', '弱光拍摄', '夜间人像'],
    content: [
      { type: 'heading', level: 2, content: '夜景自拍的三大挑战' },
      { type: 'paragraph', content: '夜景自拍之所以困难，主要面临三大问题：光线不足导致画面噪点多、手抖导致画面模糊、以及背景灯光和人脸的曝光难以平衡。但好消息是，最新的国产手机在夜景算法上进步神速，配合正确的拍摄技巧，完全可以拍出令人惊艳的夜景自拍。' },
      { type: 'heading', level: 2, content: '选对位置：寻找环境光源' },
      { type: 'paragraph', content: '夜景自拍不是在全黑环境下拍摄。相反，你应该主动寻找有趣的环境光源——街边的霓虹灯、商场的橱窗、路灯下的光晕，都是绝佳的天然补光灯。让你的脸靠近这些光源，可以获得柔和且富有氛围感的面部照明。繁华的商业街和夜市是夜景自拍的理想场所。' },
      { type: 'heading', level: 2, content: '稳定至上：防抖技巧大全' },
      { type: 'paragraph', content: '夜景模式下，手机需要更长的曝光时间来收集足够的光线，这就对稳定性提出了更高要求。除了使用三脚架，你还可以将手机靠在栏杆、墙壁等稳固物体上。如果没有支撑物，双手握持时可以将手肘紧贴身体两侧，形成人体三脚架。大多数国产手机都支持声控拍照或手势拍照，使用这些功能避免触碰屏幕造成的抖动。' },
      { type: 'heading', level: 2, content: '善用夜景模式' },
      { type: 'paragraph', content: '几乎所有国产手机现在都配备了专门的夜景模式。开启夜景模式后，手机会自动拍摄多张不同曝光的照片并合成，大幅提升暗部细节和整体亮度。注意在夜景模式下保持1-3秒的稳定，直到屏幕上出现拍摄完成的提示再移动手机。' },
      { type: 'list', items: ['开启夜景模式/HDR模式，让手机自动优化暗部细节', '利用环境光源（霓虹灯、橱窗、路灯）为面部补光', '使用三脚架或将手机靠在稳固物体上防止模糊', '打开网格线确保画面水平和构图工整', '拍摄后用修图App微调亮度和噪点'] },
      { type: 'tip', content: '进阶玩法：尝试使用专业模式手动控制参数。将ISO设置在400-800之间（过高会产生噪点），快门速度设置在1/15秒以上（过慢容易糊片），然后根据实际效果微调。虽然需要一些练习，但一旦掌握，你就能在各种极限光线下拍出完美自拍。' },
    ],
  },
  {
    slug: 'xiaohongshu-zimei-yunying',
    title: '小红书自拍博主运营心法：从0到10万粉的成长之路',
    excerpt: '采访多位小红书自拍赛道万粉博主，总结出内容定位、拍摄风格、发布时间等核心运营策略，分享给想做自拍账号的你。',
    category: 'zimei-jingyan',
    author: '运营分析师阿杰',
    date: '2024-08-22',
    readTime: '9分钟',
    imageSeq: 'social-media-selfie-blogger',
    featured: false,
    tags: ['小红书运营', '自拍博主', '自媒体涨粉', '内容创作'],
    content: [
      { type: 'heading', level: 2, content: '自拍赛道的机会与挑战' },
      { type: 'paragraph', content: '小红书的"自拍"相关话题累计浏览量已超过百亿，是一个流量巨大的赛道。但正因为门槛低、参与者众多，想要从中脱颖而出也并非易事。我们采访了5位从素人到万粉的自拍博主，总结出以下可复制的成长路径。' },
      { type: 'heading', level: 2, content: '第一步：找准你的自拍定位' },
      { type: 'paragraph', content: '不要做"什么风格都发"的泛自拍账号。成功的博主都有清晰的定位：有人专注于"自然感自拍教程"，有人主打"复古胶片风"，有人深耕"通勤穿搭+自拍"。找到一个你擅长且市场有需求的方向，持续深耕。国产自拍领域的细分赛道还有很多空白，越早找到自己的独特定位越好。' },
      { type: 'heading', level: 2, content: '第二步：打造统一的视觉风格' },
      { type: 'paragraph', content: '翻看任何一位成功博主的首页，你会发现她们的封面图风格高度统一——统一的色调、统一的字体、统一的排版。这种"视觉一致性"能让用户在瀑布流中一眼认出你的内容。建议创建一个专属的封面模板，每次发布时只需替换照片和标题即可，既高效又能建立品牌辨识度。' },
      { type: 'heading', level: 2, content: '第三步：内容规划与发布节奏' },
      { type: 'paragraph', content: '据我们采访的博主反馈，保持每周3-4篇的更新频率是涨粉效果最好的节奏。内容类型可以按"教程贴：日常分享：互动话题 = 4：4：2"的比例来规划。教程贴负责吸引精准粉丝，日常分享维持账号温度，互动话题提升评论区活跃度，三者缺一不可。' },
      { type: 'list', items: ['发布频率：每周3-4篇，保持稳定更新', '内容配比：教程40% + 日常分享40% + 互动话题20%', '发布时间：工作日晚8-10点，周末早10-11点', '封面设计：统一色调和字体，建立视觉辨识度', '标签策略：2个热门标签 + 3个精准标签 + 1个品牌标签'] },
      { type: 'tip', content: '博主们都强调的一个关键点是：不要只发美照，要发"可复制的教程"。用户不只是来看你美，更想学到如何变美的方法。每篇笔记都要思考：这篇内容能给读者带来什么价值？是让她们学到了一个新角度，还是掌握了一个新技巧？' },
    ],
  },
];